<template>
  <section class="basic-header">
    <div class="header-inner">
      <a class="a-item">
        <a-icon type="menu" @click="handleMenu"></a-icon>
      </a>
      <a class="a-item">
        <a-icon type="logout" @click="handleLogout"></a-icon>
      </a>
    </div>
    <MenuShowMobile ref="menuShowMobile"></MenuShowMobile>
  </section>
</template>

<script>
import {HttpMixins} from "@/mixins/http-mixins";
import MenuShowMobile from "@/components/MenuShowMobile.vue";

export default {
  name: "HeaderMobile",
  components: {MenuShowMobile},
  mixins: [HttpMixins],
  data() {
    return {
      country: '',
      bronzeNum: '0',
      silverNum: '0',
      ironNum: '0',
      account: localStorage.getItem('username'),
      url: {
        logout: window._CONFIG['domainURL'] + "/auth/logout",
      }
    }
  },
  created() {
    let country = localStorage.getItem('country');
    if (!country) {
      localStorage.setItem('country', '美国');
      country = '美国';
    }
    this.country = country;
  },
  methods: {
    handleMenu() {
      this.$refs.menuShowMobile.show();
    },
    handleLogout() {
      let that = this;
      that.$router.push({path: '/login'})
      // that.$axios.put(that.url.logout, {}, {headers: that.headers}).then((res) => {
      //   let response = res.data;
      //   if (response.code === 200) {
      //     that.$router.push({path: '/login'})
      //   } else {
      //     that.$message.error(response.msg);
      //   }
      // }).catch(function (error) {
      //   that.$message.error(error);
      // });
    },
  },
}
</script>

<style scoped>

.basic-header {
  background: #4a90e2;
}

.header-inner {
  max-width: 1800px;
  width: 100%;
  height: 48px;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  padding: 0 15px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.a-item {
  color: white;
  display: flex;
  height: 100%;
  align-items: center;
}

.a-item i {
  font-size: 20px;
}


</style>
